/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { AxiosInstance, AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IPortalJobs {
    getJobs(
        statuses: JobStatusWeb[] | undefined,
        number: string | undefined,
        locationIds: number[] | undefined,
        jobTypeIds: number[] | undefined,
        serviceAgreementIds: number[] | undefined,
        start: Date | null | undefined,
        end: Date | null | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<JobSearchResultWeb>;
    getJobCounts(cancelToken?: CancelToken): AxiosPromise<JobCounts>;
    getJob(
        id: number,
        statuses: JobAppointmentStatusWeb[] | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<JobListItemWeb>;
    getJobAppointments(
        id: number,
        statuses: JobAppointmentStatusWeb[] | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<JobAppointmentsResult>;
    getUnscheduledVisits(
        locationIds: number[] | undefined,
        serviceAgreementIds: number[] | undefined,
        start: Date | null | undefined,
        end: Date | null | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<VisitsResult>;
    getJobTypeFilters(
        statuses: JobStatusWeb[] | undefined,
        number: string | undefined,
        locationIds: number[] | undefined,
        jobTypeIds: number[] | undefined,
        serviceAgreementIds: number[] | undefined,
        start: Date | null | undefined,
        end: Date | null | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<JobTypeFilterResult>;
    getServiceAgreementFilters(
        locationIds: number[] | undefined,
        statuses: AgreementStatus[] | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<ServiceAgreementFilterResult>;
}

export const BASE_URL_TOKEN_PortalJobs = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class PortalJobs implements IPortalJobs {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
        private readonly axios: AxiosInstance,
        @inject(BASE_URL_TOKEN_PortalJobs) @optional() private readonly baseUrl = ''
    ) {}

    getJobs(
        statuses: JobStatusWeb[] | undefined,
        number: string | undefined,
        locationIds: number[] | undefined,
        jobTypeIds: number[] | undefined,
        serviceAgreementIds: number[] | undefined,
        start: Date | null | undefined,
        end: Date | null | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<JobSearchResultWeb> {
        let url_ = '/v1/customerportal2/jobs?';
        if (statuses === null) throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses &&
                statuses.forEach(item => {
                    url_ += 'statuses=' + encodeURIComponent('' + item) + '&';
                });
        if (number === null) throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined) url_ += 'number=' + encodeURIComponent('' + number) + '&';
        if (locationIds === null) throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined)
            locationIds &&
                locationIds.forEach(item => {
                    url_ += 'locationIds=' + encodeURIComponent('' + item) + '&';
                });
        if (jobTypeIds === null) throw new Error("The parameter 'jobTypeIds' cannot be null.");
        else if (jobTypeIds !== undefined)
            jobTypeIds &&
                jobTypeIds.forEach(item => {
                    url_ += 'jobTypeIds=' + encodeURIComponent('' + item) + '&';
                });
        if (serviceAgreementIds === null)
            throw new Error("The parameter 'serviceAgreementIds' cannot be null.");
        else if (serviceAgreementIds !== undefined)
            serviceAgreementIds &&
                serviceAgreementIds.forEach(item => {
                    url_ += 'serviceAgreementIds=' + encodeURIComponent('' + item) + '&';
                });
        if (start !== undefined && start !== null)
            url_ += 'start=' + encodeURIComponent(start ? '' + start.toJSON() : '') + '&';
        if (end !== undefined && end !== null)
            url_ += 'end=' + encodeURIComponent(end ? '' + end.toJSON() : '') + '&';
        if (page === null) throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (includeTotal === null) throw new Error("The parameter 'includeTotal' cannot be null.");
        else if (includeTotal !== undefined)
            url_ += 'includeTotal=' + encodeURIComponent('' + includeTotal) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<JobSearchResultWeb>(options_));
    }

    getJobCounts(cancelToken?: CancelToken): AxiosPromise<JobCounts> {
        let url_ = '/v1/customerportal2/jobs/counts';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<JobCounts>(options_));
    }

    getJob(
        id: number,
        statuses: JobAppointmentStatusWeb[] | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<JobListItemWeb> {
        let url_ = '/v1/customerportal2/jobs/{id}?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (statuses === null) throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses &&
                statuses.forEach(item => {
                    url_ += 'statuses=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<JobListItemWeb>(options_));
    }

    getJobAppointments(
        id: number,
        statuses: JobAppointmentStatusWeb[] | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<JobAppointmentsResult> {
        let url_ = '/v1/customerportal2/jobs/{id}/appointments?';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        if (statuses === null) throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses &&
                statuses.forEach(item => {
                    url_ += 'statuses=' + encodeURIComponent('' + item) + '&';
                });
        if (page === null) throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<JobAppointmentsResult>(options_));
    }

    getUnscheduledVisits(
        locationIds: number[] | undefined,
        serviceAgreementIds: number[] | undefined,
        start: Date | null | undefined,
        end: Date | null | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<VisitsResult> {
        let url_ = '/v1/customerportal2/jobs/unscheduledvisits?';
        if (locationIds === null) throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined)
            locationIds &&
                locationIds.forEach(item => {
                    url_ += 'locationIds=' + encodeURIComponent('' + item) + '&';
                });
        if (serviceAgreementIds === null)
            throw new Error("The parameter 'serviceAgreementIds' cannot be null.");
        else if (serviceAgreementIds !== undefined)
            serviceAgreementIds &&
                serviceAgreementIds.forEach(item => {
                    url_ += 'serviceAgreementIds=' + encodeURIComponent('' + item) + '&';
                });
        if (start !== undefined && start !== null)
            url_ +=
                'start=' +
                encodeURIComponent(start ? '' + moment(start).format('YYYY-MM-DDTHH:mm:ss') : '') +
                '&';
        if (end !== undefined && end !== null)
            url_ +=
                'end=' +
                encodeURIComponent(end ? '' + moment(end).format('YYYY-MM-DDTHH:mm:ss') : '') +
                '&';
        if (page === null) throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (includeTotal === null) throw new Error("The parameter 'includeTotal' cannot be null.");
        else if (includeTotal !== undefined)
            url_ += 'includeTotal=' + encodeURIComponent('' + includeTotal) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<VisitsResult>(options_));
    }

    getJobTypeFilters(
        statuses: JobStatusWeb[] | undefined,
        number: string | undefined,
        locationIds: number[] | undefined,
        jobTypeIds: number[] | undefined,
        serviceAgreementIds: number[] | undefined,
        start: Date | null | undefined,
        end: Date | null | undefined,
        page: number | undefined,
        pageSize: number | undefined,
        includeTotal: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<JobTypeFilterResult> {
        let url_ = '/v1/customerportal2/jobs/filters/jobtypes?';
        if (statuses === null) throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses &&
                statuses.forEach(item => {
                    url_ += 'statuses=' + encodeURIComponent('' + item) + '&';
                });
        if (number === null) throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined) url_ += 'number=' + encodeURIComponent('' + number) + '&';
        if (locationIds === null) throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined)
            locationIds &&
                locationIds.forEach(item => {
                    url_ += 'locationIds=' + encodeURIComponent('' + item) + '&';
                });
        if (jobTypeIds === null) throw new Error("The parameter 'jobTypeIds' cannot be null.");
        else if (jobTypeIds !== undefined)
            jobTypeIds &&
                jobTypeIds.forEach(item => {
                    url_ += 'jobTypeIds=' + encodeURIComponent('' + item) + '&';
                });
        if (serviceAgreementIds === null)
            throw new Error("The parameter 'serviceAgreementIds' cannot be null.");
        else if (serviceAgreementIds !== undefined)
            serviceAgreementIds &&
                serviceAgreementIds.forEach(item => {
                    url_ += 'serviceAgreementIds=' + encodeURIComponent('' + item) + '&';
                });
        if (start !== undefined && start !== null)
            url_ += 'start=' + encodeURIComponent(start ? '' + start.toJSON() : '') + '&';
        if (end !== undefined && end !== null)
            url_ += 'end=' + encodeURIComponent(end ? '' + end.toJSON() : '') + '&';
        if (page === null) throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
        if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
        if (includeTotal === null) throw new Error("The parameter 'includeTotal' cannot be null.");
        else if (includeTotal !== undefined)
            url_ += 'includeTotal=' + encodeURIComponent('' + includeTotal) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<JobTypeFilterResult>(options_));
    }

    getServiceAgreementFilters(
        locationIds: number[] | undefined,
        statuses: AgreementStatus[] | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<ServiceAgreementFilterResult> {
        let url_ = '/v1/customerportal2/jobs/filters/serviceAgreements?';
        if (locationIds === null) throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined)
            locationIds &&
                locationIds.forEach(item => {
                    url_ += 'locationIds=' + encodeURIComponent('' + item) + '&';
                });
        if (statuses === null) throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses &&
                statuses.forEach(item => {
                    url_ += 'statuses=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<ServiceAgreementFilterResult>(options_));
    }
}

export interface JobSearchResultWeb {
    page: number;
    pageSize: number;
    hasMore: boolean;
    totalCount?: number | undefined;
    data?: JobListItemWeb[] | undefined;
    unfilteredTotalCount: number;
}

export interface JobListItemWeb {
    id: number;
    number?: string | undefined;
    type?: string | undefined;
    status: JobListItemStatus;
    appointmentCount: number;
    firstNotCompletedAppointmentStartDate?: Date | undefined;
    firstNotCompletedAppointmentEndDate?: Date | undefined;
    lastAppointmentStartDate?: Date | undefined;
    lastAppointmentEndDate?: Date | undefined;
    serviceAgreementId?: number | undefined;
    serviceAgreementName?: string | undefined;
    proposal?: JobItemProposalWeb | undefined;
    serviceLocation?: LocationModel | undefined;
    invoice?: JobInvoiceDetails | undefined;
}

export enum JobListItemStatus {
    Scheduled = 0,
    InProgress = 2,
    OnHold = 3,
    Completed = 4,
    Canceled = 5,
}

export interface JobItemProposalWeb {
    id: string;
    name: string;
    estimates: JobItemProposalEstimateWeb[];
}

export interface JobItemProposalEstimateWeb {
    id: number;
    name?: string | undefined;
    summary?: string | undefined;
    status: EstimateStatus;
    expired: boolean;
    optionName?: string | undefined;
    optionColorHex?: string | undefined;
    imageUrl?: string | undefined;
    subTotal?: number | undefined;
    totalTax?: number | undefined;
    totalPrice?: number | undefined;
    selected?: boolean | undefined;
    createdById?: number | undefined;
    businessUnitId?: number | undefined;
}

export enum EstimateStatus {
    Open = 0,
    Sold = 1,
    Dismissed = 2,
}

export interface LocationModel {
    id: number;
    name: string;
    address?: AddressModel | undefined;
}

export interface AddressModel {
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    unit?: string | undefined;
}

export interface JobInvoiceDetails {
    invoiceId?: string | undefined;
    balance: number;
    amount: number;
    dueDate?: Date | undefined;
    summary?: string | undefined;
    isAccessible: boolean;
}

export enum JobStatusWeb {
    Scheduled = 0,
    InProgress = 2,
    OnHold = 3,
    Completed = 4,
    Canceled = 5,
}

export interface JobCounts {
    inProgress: number;
    onHold: number;
    upcoming: number;
    completed: number;
    canceled: number;
}

export enum JobAppointmentStatusWeb {
    Scheduled = 0,
    Dispatched = 1,
    Working = 2,
    Hold = 3,
    Done = 4,
    Canceled = 5,
}

export interface JobAppointmentsResult {
    page: number;
    pageSize: number;
    hasMore: boolean;
    totalCount?: number | undefined;
    data?: JobAppointmentItem[] | undefined;
}

export interface JobAppointmentItem {
    id: number;
    number?: string | undefined;
    status: JobAppointmentItemStatus;
    startDate: Date;
    endDate: Date;
    arrivalWindowPlanStartDate?: Date | undefined;
    arrivalWindowPlanEndDate?: Date | undefined;
    technicians?: AppointmentTechnicianItem[] | undefined;
    holdLog?: HoldLog | undefined;
    /** JWT token for rescheduling this appointment via the scheduler service. Null if token generation failed or is unavailable. */
    rescheduleToken?: string | undefined;
}

export enum JobAppointmentItemStatus {
    Scheduled = 0,
    Dispatched = 1,
    Working = 2,
    OnHold = 3,
    Completed = 4,
    Canceled = 5,
}

export interface AppointmentTechnicianItem {
    id: number;
    name?: string | undefined;
    photoUrl?: string | undefined;
}

export interface HoldLog {
    reason?: string | undefined;
    comment?: string | undefined;
}

export interface VisitsResult {
    page: number;
    pageSize: number;
    hasMore: boolean;
    totalCount?: number | undefined;
    data?: VisitListItem[] | undefined;
    unfilteredTotalCount: number;
}

export interface VisitListItem {
    id: number;
    name?: string | undefined;
    jobTypeName?: string | undefined;
    startDate: Date;
    endDate: Date;
    locationAddress?: AddressModel | undefined;
    serviceAgreementName?: string | undefined;
    status: VisitStatusCpoVersion;
}

/** Customer Portal's mapped version of VisitProgressStatus */
export enum VisitStatusCpoVersion {
    Upcoming = 0,
    Completed = 1,
    Canceled = 2,
}

export interface JobTypeFilterResult {
    jobTypes?: { [key: string]: string } | undefined;
}

export interface ServiceAgreementFilterResult {
    serviceAgreementFilters?: { [key: string]: string } | undefined;
}

export enum AgreementStatus {
    Draft = 0,
    Sent = 1,
    Rejected = 2,
    Accepted = 3,
    Activated = 4,
    Canceled = 5,
    Expired = 6,
    Hold = 7,
    AutoRenew = 8,
}
